import DevourClient from 'devour-client';

export const TYPE = 'news/post';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			title: '',
			content: '',
			location: '',
			relevantFrom: '',
			relevantUntil: '',
			postedAt: '',
			orientation: '',
			favoritesCount: '',
			type: '',
			slug: '',
			image: {},
			imageMeta: {},
			videoUrl: '',
			comments: {
				jsonApi: 'hasMany',
				type: 'comment',
			},
			favorites: {
				jsonApi: 'hasMany',
				type: 'favorite',
			},
			favoriter: {
				jsonApi: 'hasOne',
				type: 'user/favorite',
			},
		},
		{
			type: TYPE,
		}
	);

	return client;
}
